import { uptime } from '~/helpers/fields-description';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';
import apiService from '~/services/api.service';
import { LoadingModule } from '~common-store/modules/loading';
import { PopupModule } from '~common-store/modules/popup';
export class LegrandGateway extends Gateway {

    get fieldUptime(): FieldObject | undefined {
        return uptime(this.uptime);
    }

    getNetworkFields(): FieldObject[] {
        let fields = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }
        return fields;
    }

    getLocalResources = async () => {
        try {
            LoadingModule.showLoading(true);
            return (await apiService.getlocalresources({ home_id: this.homeId || '', device_id: this.id })).data.body;
        } catch (error) {
            return 'Error while getting local resources';
        } finally {
            PopupModule.setLastExecuted(new Date());
            LoadingModule.showLoading(false);
        }
    }
    resetMigrationFlag = async () => {
        try {
            await this.handleOperation({
                callback: () => apiService.resetmigrationflag({ device_id: this.id }),
                confirmText: 'You are about to reset the migration flag, do you want to continue?',
            });
            window.location.reload();
        } catch (error) {
            return;
        }
    }

    resetMigrationSecret = async () => {
        await this.handleOperation({
            callback: () => apiService.resetmigrationsecret({ device_id: this.id }),
            confirmText: 'You are about to reset the migration secret, do you want to continue?',
        });
    }

    rollbackMigration = async () => {
        this.handleOperation({
            callback: async () => {
                try {
                    await apiService.rollbackmigration({ device_id: this.id, migrated: false });
                    // reset device if there is no error on rollbackmigration
                    await apiService.adminresetdevice({ device_id: this.id });
                    window.location.reload();
                } catch (error) {
                    console.error(error);
                }
            },
            confirmText: 'You are about to rollback the migration, do you want to continue?',
        });
    }
}

